import React from 'react';

// Types
import { User } from 'Shared/constants/types';

// Hooks
import { useBaTracking } from 'Shared/tracking/use-ba-tracking';
import { useCreateOrSendBa } from 'Shared/utils/hooks/use-create-or-send-ba';

// Components
import BaseCta from './BaseCta';
import { Illustrations } from 'Wpds/components/illustration';
import ExternalLinksConstants from 'Shared/constants/ExternalLinks.constants';

type Props = {
  user: User;
};

const SendBa = ({ user, ...rest }: Props) => {
  const { trackSendAssessmentButtonClick } = useBaTracking();
  const { sendBaEmail, isCreatingBaLink } = useCreateOrSendBa({ user: user, isTakingBaForSelf: false });

  const handleButtonClick = async () => {
    trackSendAssessmentButtonClick();
    await sendBaEmail();
  };

  return (
    <BaseCta
      title={`Send ${user.firstName} the PI Behavioral Assessment.`}
      illustration={Illustrations.take_ba}
      description="Make your meetings even more productive. Uncover your biggest relationship strengths and caution areas, and get tips to work better together."
      buttonText="Send assessment"
      buttonSize="lg"
      footerText="Learn More"
      footerLink={ExternalLinksConstants.learn_more_about_taking_ba}
      onButtonClick={handleButtonClick}
      loading={isCreatingBaLink}
      {...rest}
    />
  );
};

export default SendBa;
